import { render, staticRenderFns } from "./OductovaneKorekcePncZaObdobi.vue?vue&type=template&id=2a4ba596&"
import script from "./OductovaneKorekcePncZaObdobi.vue?vue&type=script&lang=ts&"
export * from "./OductovaneKorekcePncZaObdobi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports